import useSWR from "swr";
import * as fetcher from "../fetcher";

export function usePricerange() {
  return useSWR<{ maxAmount: number; minAmount: number }>(
    `/pricerange`,
    (url) => fetcher.opportunity.get(url)
  );
}
